exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card3[data-v-2d9511a4]{display:flex;align-items:center;justify-content:space-between;border-radius:20px;padding:15px 18px;width:281px;box-shadow:0 2px 4px 0 rgba(0,0,0,.1);background:#e6362c;font-weight:700;font-size:17px;color:#fff;line-height:22px}.fs18[data-v-2d9511a4]{font-size:18px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2d9511a4","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Content/src/components/MyProgress/Daccord/FinishBanner.vue
// module id = 906
// module chunks = 1